import {Component} from '@angular/core';

@Component({
    selector: 'ffmpeg',
    template:`<div class="panel panel-default" style="padding: 10px;">
                <button data-toggle="collapse" href="#ffmpeg" role="button" aria-expanded="false"
                        aria-controls="ffmpeg" type="button" class="btn btn-primary ">Add FFMPEG Script
                </button>
                <div class="collapse" id="ffmpeg">
                    <table>
                        <tr>
                            <textarea id="w3mission" rows="10" cols="180"></textarea>
                        </tr>
                        <tr>
                            <button type="button" class="btn btn-success btn-sm ffmpegOkBtn" data-toggle="tooltip" data-placement="bottom"
                                    title="Create Table" (click)="onCreateFfmpegScript()">
                                Create FFMPEG Script
                            </button>
                        </tr>
                    </table>
                </div>
    </div>`,
    styles:[`.ffmpegOkBtn{float:right;}`]
})

export class FfmpegDefinitionComponent {
    onCreateFfmpegScript() {
    }
}
